import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, routes } from "../config/routes";
import { JobApiItem } from "../types";

export type { JobApiItem };

export const useJobs = () => {
  const [jobs, setJobs] = useState<JobApiItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`${baseUrl}${routes.jobs}`, {
          params: { pagination: { pageSize: 100 } },
          headers: { Accept: "application/json" },
        });
        setJobs(Array.isArray(data.data) ? data.data : []);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to fetch jobs");
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, [baseUrl]);

  const getAvailableDepartments = () => {
    const departments = jobs
      .map((job) => job.jobDepartment)
      .filter((status) => status !== "Draft" && status !== "Archived");

    return [...new Set(departments)];
  };

  const filterJobsByDepartment = (department: string) => {
    const filteredJobs = jobs.filter(
      (job: JobApiItem) =>
        job.jobDepartment === department && job.jobStatus !== "Draft"
    );

    setJobs(filteredJobs);
  };

  const getJobsDetails = async (id: string) => {
    const { data } = await axios.get(
      `${baseUrl}${routes.jobDetails.replace(":id", id)}`,
      {
        headers: { Accept: "application/json" },
      }
    );

    return data.data;
  };

  return {
    jobs,
    loading,
    error,
    getAvailableDepartments,
    filterJobsByDepartment,
    getJobsDetails,
  };
};
